import script from "./UserSubscriptionRenew.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSubscriptionRenew.vue?vue&type=script&setup=true&lang=js"

import "./UserSubscriptionRenew.vue?vue&type=style&index=0&id=2f9465ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f9465ce"]])

export default __exports__